import {
  addLogFeatureFlags,
  initLogging as initSentryLogging,
} from 'common/logging'

import { ENV_SETTINGS } from '../global/envSettings'
import { getFeatures } from '../sharedLegacy/hooks/useFeatures'
import { getRoomInfo } from '../global/blocs/roomInfo'

const AUDIENCE_DSN =
  'https://9c2eee0415d05eb7bf051a19c10c7b32@o4511847050313728.ingest.de.sentry.io/4511847073710160'

const initLogging = () => {
  const roomInfo = getRoomInfo()

  // just in case, and it simplifies logic downstream
  if (roomInfo.role !== 'audience') return

  const client = initSentryLogging({
    dsn: AUDIENCE_DSN,
    release: build.SHA_SIGNATURE,
    environment: ENV_SETTINGS.environment,
    initialScope: {
      tags: {
        liveId: roomInfo.liveId,
        role: roomInfo.role,
      },
    },
  })
  if (!client) return

  void getFeatures().then(addLogFeatureFlags)
}

export { initLogging }
